module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P-P19"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P20"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "P-P21"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P22"
  }, [_vm._v("For Honey, Uncle Buddy, and Aunt Charline")]), _vm._v(" "), _c('p', {
    staticClass: "P-P22"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P22"
  }, [_vm._v("For Don and Dona")]), _vm._v(" "), _c('p', {
    staticClass: "P-P23"
  }), _vm._v(" "), _c('p', {
    staticClass: "P-P23"
  }, [_vm._v("For my husband Dan and our children Briley and Adeline")]), _vm._v(" "), _c('p', {
    staticClass: "P-P24"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "P-P24"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "P-P24"
  }, [_vm._v("www.carrienyman.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 63
// module chunks = 0